export const ACTIVE_MENU = 'account-messages-menu';
export const KEY_CURRENT_PAGE = 'account-messages-page';
export const KEY_SHOW_MESSAGE_TOOLS = 'account-messages-show-messages-tools';
export const NEW = 1;
export const SENT = 2;
export const TRASH = 3;
export const INBOX = 4;
